<!-- h5/视频 -->
<template>
    <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length > 0 ? '没有更多了' : ''"
        @load="getList"
    >
      <ul class="list">
        <li @click="$router.push('/supplier-details')">
          <p class="item-name">AUTOSAR 工程师</p>
          <ul class="img-list">
            <li>
              <img src="../../assets/img.png" class="img">
            </li>
            <li>
              <img src="../../assets/img.png" class="img">
            </li>
            <li>
              <img src="../../assets/img.png" class="img">
            </li>
          </ul>
          <div class="item-bottom">
            <ul class="tag-list">
              <li>青岛安泰科气体有限公司</li>
              <li>建筑石材</li>
            </ul>
            <span class="number">1176 浏览</span>
          </div>
        </li>
        <li @click="$router.push('/supplier-details')">
          <p class="item-name">AUTOSAR 工程师</p>
          <ul class="img-list">
            <li>
              <img src="../../assets/img.png" class="img">
            </li>
          </ul>
          <div class="item-bottom">
            <ul class="tag-list">
              <li>青岛安泰科气体有限公司</li>
              <li>建筑石材</li>
            </ul>
            <span class="number">1176 浏览</span>
          </div>
        </li>
        <div class="normal-box-small">
          <img src="../../assets/normal.png">
          暂无数据
        </div>
      </ul>
    </van-list>

</template>

<script>
import {ArticleService, UserCenterService} from "@/common/service";
import {Dialog} from "vant";

  export default {
		components: {},
		data() {
			return {
        showReport: false,
        showOpenVip: false,
        // 举报参数
        reportParams: {
          type: 5,  // 举报类型（1视频2评论3会员4资料5图文）
          report_id: 0,  // 举报内容的id
        },
        params: {
          type: 0,  // 类型1单个2系列
          is_tj: 1,  // 是否推荐0否1是
          page: 1,  // 页数
          page_num: 20,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,

        isLogin: false,
        isVip: false,
			};
		},
    mounted() {
      // this.getUserInfo();
    },
    methods: {
      getList() {
        return;
        this.loading = true;
        ArticleService.getArticleList(this.params).then(({ data }) => {
          const list = data.list;
          // 展开集合视频，并合并到列表
          // const list = data.list.reduce((arr, item) => {
          //   const {id, label_name, video_arr} = item;
          //   // 展开集合视频
          //   const newList = video_arr.map(item2 => ({
          //     ...item2,
          //     videoArrId: item2.id,
          //     id,
          //     label_name,
          //     video_arr,
          //   }))
          //   // 判断是否是集合，是则将集合合并到列表
          //   if (video_arr.length > 1) {
          //     arr.push({ ...video_arr[0], videoArrId: video_arr[0].id, ...item});
          //   }
          //   // 集合视频合并到列表
          //   arr.push(...newList);
          //   return arr;
          // }, []);
          this.list = this.params.page === 1 ? list : [...this.list, ...list];
          if (list.length < this.params.page_num) {
            this.finished = true;
          } else {
            this.params.page++;
          }
        }).finally(() => {
          this.loading = false;
        });
      },

      getUserInfo() {
        UserCenterService.getUserInfo().then(({ data }) => {
          this.isLogin = true;
          const userLevel = data.user_level;
          if (userLevel && userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(userLevel.end_date.replace(/-/g, '/')).getTime();
            this.isVip = currentTime < endTime;
          }
        });
      },
      toDetail(id, item_id, is_vip) {
        if (is_vip === 1) {
          if (!this.isLogin) {
            return Dialog.confirm({
              message: 'VIP图文请登录后查看',
              confirmButtonText: '去登录'
            }).then(() => {
              this.$router.push('/login');
            });
          }
          if (!this.isVip) {
            return this.showOpenVip = true;
          }
        }
        this.$router.push(`/image-text-details?id=${id}&item_id=${item_id}`)
      }
    },
	}
</script>

<style scoped>

.list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  box-sizing: border-box;
}

.list>li {
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 14px;
  box-sizing: border-box;
}


.item-name {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  color: #222222;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}


.normal-box-small {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #999992;
  padding: 120px 0;
}

.normal-box-small>img {
  width: 150px;
  margin-bottom: 9px;
}

.img-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.img-list>li {
  flex: 1;
  position: relative;
  overflow: hidden;
  margin-right: 7px;
}

.img-list>li:last-child {
  margin-right: 0;
}

.img-list>li>img {
  width: 100%;
  height: 100px;
  border-radius: 12px;
  display: block;
  object-fit: cover;
}

.item-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.tag-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.tag-list>li {
  height: 18px;
  line-height: 18px;
  display: flex;
  align-items: center;
  font-size: 10px;
  width: fit-content;
  padding: 0 6px;
  border-radius: 2px;
  margin-right: 10px;
}

.tag-list>li:nth-child(odd) {
  color: #2A63F3;
  background-color: #E7F1FF;
}

.tag-list>li:nth-child(even) {
  color: #4FA753;
  background-color: #E8F6EA;
}

.number {
  color: #999999;
  font-size: 10px;
}
</style>
